module.exports = __webpack_public_path__ + "static/media/Swimmers’ Waffle.3c6b48e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/store/Swimmers’ Waffle.png
// module id = 332
// module chunks = 10